export default __webpack_public_path__ + "static/media/columbine-high-school.0ed14f27.jpg";